module.exports = __webpack_public_path__ + "static/img/card_btn_PC.7613aefe.png";